<template>
  <section class="module-photo sg-space">
    <headlineCategory
      v-if="showMoreTitle"
      :headlineTitle="headlineTitle"
      :headline-more-title="showMoreTitle?.title"
      :url="showMoreTitle?.url"
      :routing-data="showMoreTitle?.routing_data"
      :type="showMoreTitle?.type"
      :is-app-link="showMoreTitle ? true : false"
      :headlineHomePage="true"
    />
    <headline v-else :headlineTitle="headlineTitle" />
    <app-link
      class="module-photo__gallery"
      :to="mainGallery.url"
      :routing-data="mainGallery.routing_data"
      :path-type="mainGallery.type"
    >
      <div class="container">
        <div class="columns">
          <div class="column is-4-desktop is-12-mobile"></div>
          <div class="column is-8-desktop is-12-tablet is-12-mobile">
            <div class="module-photo__img">
              <photo-loader
                :image="mainGallery.image"
                height-skeletor="779"
                :imgWidth="930"
                :imgHeight="525"
              />
            </div>
          </div>
        </div>
      </div>
    </app-link>
    <div class="module-photo__info">
      <div class="container">
        <div class="module-photo__content">
          <div class="columns module-photo__content-left">
            <app-link
              class="module-photo__description"
              :to="mainGallery.url"
              :routing-data="mainGallery.routing_data"
              :path-type="mainGallery.type"
            >
              <h3 class="module-photo__description--title">{{ getArticleTitle(mainGallery) }}</h3>
              <p class="module-photo__description--text">{{ mainGallery.lead }}</p>
            </app-link>
          </div>
          <div class="columns module-photo__content-right">
            <div class="column is-6-desktop is-12-tablet is-12-mobile">
              <div class="module-photo__example">
                <app-link
                  v-for="(item, key) in shortGallery"
                  class="module-photo__example--box"
                  :to="mainGallery.url"
                  :routing-data="mainGallery.routing_data"
                  :path-type="mainGallery.type"
                  :key="key"
                >
                  <photo-loader
                    :image="item"
                    height-skeletor="132"
                    :imgWidth="350"
                    :imgHeight="200"
                  />
                </app-link>
                <app-link
                  class="module-photo__example--box see-more"
                  :to="mainGallery.url"
                  :routing-data="mainGallery.routing_data"
                  :path-type="mainGallery.type"
                >
                  <span> zobacz <br />wszystkie</span>
                </app-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

import Headline from '@/components/elements/headline.vue'
import headlineCategory from '@/components/elements/headlineCategory.vue'
import PhotoLoader from '@/components/elements/PhotoLoader.vue'
import AppLink from '@/components/layout/AppLink.vue'
import {useUtils} from "@/composables/useUtils";

const props = defineProps({
  context: Object
})

const { getArticleTitle } = useUtils()

const headlineTitle = computed(() => props.context?.title ?? 'Foto')
const showMoreTitle = computed(() => props.context?.show_more)

const mainGallery = computed(() => props.context.items[0])
const shortGallery = computed(() => mainGallery.value.images?.slice(0, 2) ?? [])
</script>

<style lang="scss">
@import '@/assets/scss/components/modules/module-photo.scss';
</style>
